
































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { LOG_OUT, MUTATE_AUTH } from '@/store/modules/auth';
import { MUTATE_PHOTOS, MUTATE_TEMPLATE } from '../../store/modules/template';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';
import { MUTATE_PRODUCTS } from '../../store/modules/product';
import SearchPopover from '@/components/global/input/SearchPopover.vue';
import { findIndex } from 'lodash';
import ShowVerifyEmailMixin from '@/mixins/vue/ShowVerifyEmailMixin';

@Component({
    components: {
        SearchPopover,
    },
})
export default class Navigation extends Mixins(IsMobileMixin, ShowVerifyEmailMixin) {
    public drawer = true;

    public search = '';

    public menuList = [
        {
            value: 'profile-settings',
            label: 'Profile',
        },
        {
            value: 'wallet',
            label: 'Wallet',
        },
        {
            value: 'faq',
            label: 'FAQ',
        },
    ];

    // route of tab list
    public dashboardTabsList = [
        'analytics',
        'add-product',
        'upload-csv',
        'track-and-trace',
    ];

    public productsTabsList = [
        'products/all-products',
        'products/unclaimed',
        'products/claimed',
        'products/transferred',
    ];

    public myOrderTabList = [
        'my-order/order-list',
    ]

    public settingsTabsList = [
        'settings/profile',
        'settings/security',
    ];

    public navigationEvent(action: string, label: any) {
        this.$ga.event('Navigation', 'click', action, label);
    }

    public onMenuClick(name: string) {
        this.navigationEvent('Navigation menu', name);
        this.$router.push({ name });
    }

    public enterSearch() {
        let theSearch = '';
        if (this.search) theSearch = this.search;
        this.$router.push(`/products/all-products/${theSearch}`);
    }

    public onAddProductClick() {
        this.navigationEvent('Go to add product', '+ Add Product');
        this.$router.push('/add-product');
    }

    public async signOut() {
        this.navigationEvent('Log out', 'Log out');
        await this.$store.dispatch(LOG_OUT);
        this.$store.commit(MUTATE_TEMPLATE, []);
        this.$store.commit(MUTATE_PHOTOS, []);
        this.$store.commit(MUTATE_PRODUCTS, []);
        this.$router.replace('/signin');
    }

    get user() {
        return this.$store.getters.getUser;
    }

    get balance() {
        return this.$store.getters.getBalance;
    }

    get isDashboardListActive() {
        const index = findIndex(this.dashboardTabsList, tab => tab === this.path);
        return index !== -1;
    }

    get isProductListActive() {
        const index = findIndex(this.productsTabsList, tab => tab === this.path);
        return index !== -1;
    }

    get isMyOrderActive() {
        const index = findIndex(this.myOrderTabList, tab => tab === this.path);
        return index !== -1;
    }

    get isSettingListActive() {
        const index = findIndex(this.settingsTabsList, tab => tab === this.path);
        return index !== -1;
    }

    get path() {
        return this.$route.path.replace('/', '');
    }

    @Watch('isTablet')
    private onMobileChanged(val: string, oldVal: string) {
        if (!val) {
        // this is to make sure navigation drawer always open when the view is not mobile
            this.drawer = true;
        }
    }
}
